import React, { useState, useMemo } from 'react';
import UserAvatar from "Components/UserAvatar";
import Toolbar from '@mui/material/Toolbar';
import MuiAppBar from '@mui/material/AppBar';
import Stack from '@mui/material/Stack';

import { useAppSelector } from 'hooks/index';
import { selectUserData } from 'store/user/userSelector';
import AvatarMenu from './AvatarMenu';
import OrgNameButton from '@/operator/components/navigation/OrgNameButton';
import { selectPartnerData } from 'store/partner/partnerSelector';

interface AppBarProp {
    drawerWidth: string;
}

const AppBar: React.FC<AppBarProp> = ({ drawerWidth }) => {
    const { photoURL, name: userName } = useAppSelector(selectUserData);
    const { name: organizationName } = useAppSelector(selectPartnerData);

    // Memoize organizationName
    const memoizedOrgName = useMemo(() => organizationName, [organizationName]);

    const [anchorAvatarMenu, setAnchorAvatarMenu] =
        useState<null | HTMLElement>(null);

    const handleAvatarMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorAvatarMenu(event.currentTarget);
    };

    if (!userName && !organizationName) {
        return null;
    }

    return (
        <MuiAppBar
            sx={{ width: `calc(100% - ${drawerWidth})`, ml: `${drawerWidth}` }}
        >
            <Toolbar sx={{ justifyContent: 'flex-end' }}>
                <Stack direction="row" spacing={5} alignItems="center">
                    <OrgNameButton organizationName={memoizedOrgName} />
                    <UserAvatar
                        src={photoURL}
                        alt={userName}
                        onClick={handleAvatarMenuOpen}
                        sx={{ cursor: 'pointer' }}
                    />
                </Stack>
            </Toolbar>
            <AvatarMenu
                anchorEl={anchorAvatarMenu}
                setAnchorEl={setAnchorAvatarMenu}
            />
        </MuiAppBar>
    );
};

export default AppBar;
